import { ethers } from 'ethers';
import { z } from 'zod';

import { ApiErrorSchema, ApiResponseSchema } from './api.schema';

const message = 'Field is required';

export const OTCSchema = z.object({
  payerAddr: z.string({ message }).min(1, { message }).refine(ethers.isAddress, { message: 'Invalid EVM address' }),
  amountNode: z.number({ message }).refine(val => val > 0, { message: 'Amount of Nodes must be larger than 0' }),
  pricePerNode: z.number({ message }).refine(val => val > 0, { message: 'Price per Nodes must be larger than 0' }),
  supply: z.string({ message }).min(1, { message }),
  token: z.string({ message }).min(1, { message }),
  startedTime: z.date().optional(),
  startedDate: z.date({ message: 'Start date is required' }),
  closingTime: z.date().optional(),
  closingDate: z.date({ message: 'Closing date is required' }),
  recipients: z
    .array(
      z.object({
        id: z.string().optional(),
        name: z.string({ message }).min(1, { message }),
        address: z.string({ message }).min(1, { message }),
        percent: z.number({ message }).refine(val => val > 0, { message: 'Percentages must be larger than 0' }),
      }),
    )
    .superRefine((val, ctx) => {
      const totalPercent = val.reduce((total, cur) => total + cur.percent, 0);
      if (totalPercent !== 100) {
        ctx.addIssue({
          message: 'Total percentage must be 100',
          code: z.ZodIssueCode.custom,
        });
      } else {
        return true;
      }
    }),
  programId: z.string().optional(),
  id: z.string().optional(),
  sale: z.string().optional(),
});

const listOTCSchema = z.array(OTCSchema);

export const OTCResponseSchema = ApiResponseSchema.extend({
  data: OTCSchema,
}).merge(ApiErrorSchema);

export const OTCListResponseSchema = ApiResponseSchema.extend({
  data: listOTCSchema,
}).merge(ApiErrorSchema);

export type OTCSchemaType = z.infer<typeof OTCSchema>;
export type OTCResponseSchemaType = z.infer<typeof OTCResponseSchema>;
export type OTCListResponseSchemaType = z.infer<typeof OTCListResponseSchema>;
